// extracted by mini-css-extract-plugin
export var attorneySummary1 = "AttorneySummary1-module--attorneySummary1--27Eet";
export var contentWrapper = "AttorneySummary1-module--contentWrapper--1MO9k";
export var imageWrapper = "AttorneySummary1-module--imageWrapper--GKE75";